export default [
  {
    path: '/ai-careers',
    component: () => import('./views/Index'),
    name: 'ai_career',
    redirect: { name: 'ai_career-list' },
    children: [
      {
        path: '',
        name: 'ai_career-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: ':id',
        name: 'ai_career-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
